export const contactsData = {
    email: 'thakurkalash11@gmail.com',
    // phone: '+8801608797655',
    address: 'Bahadurgarh, Haryana - 124507 ',

    sheetAPI: ''
}